import React, { Fragment, useState } from 'react'
import { Alert, Button, Card } from 'react-bootstrap'
import { map, remove } from 'lodash'

import Secrets from './components/Secrets'
import Form from './components/Form'

const APIAuth = ({ data }) => {
  const [formIsShown, toggleForm] = useState(false)
  const [secrets, updateASecret] = useState(map(data, secret => ({ ...secret, showSecret: false })))
  const [alert, updateAlert] = useState({ show: false })
  const updateSecrets = secret => { updateASecret([...secrets, secret]) }
  const removeSecret = secret => { remove(secrets, ['id', secret.id]); updateASecret(secrets) }

  return (
    <Fragment>
      {alert.show && <Alert variant={alert.variant}>{alert.text}</Alert>}
      {!formIsShown && <Button variant='success' className='mb-3' size='sm' onClick={() => toggleForm(true)}>Add Secret</Button>}

      <Card className='p-2' style={{ width: '45%' }}>
        {formIsShown && (
          <Form {...{ updateSecrets, toggleForm, updateAlert }} />
        ) || (
          <Secrets {...{ removeSecret, updateASecret, secrets, updateAlert }} />
        )}
      </Card>
    </Fragment>
  )
}

export default APIAuth
